// extracted by mini-css-extract-plugin
module.exports = {"tagsArea":"style-module--tagsArea--69PoW","tagsTitle":"style-module--tagsTitle--1pFfy","tag":"style-module--tag--1sKMG"};